import { clamp } from '@gdladder/shared/util';
import { DevicePerformance } from '../../../context/app/AppContext';
import map from '../../../utils/map';

/**
 * Object density (objects per second) at which a level is considered to start
 * struggling on a given device tier. Below the lower bound the level is fully
 * "green" (well optimized); at the upper bound it is fully "red". Higher-end
 * devices tolerate a higher density before turning red, so the color reflects
 * how the level is likely to perform on the user's own hardware.
 */
const densityUpperBound: Record<DevicePerformance, number> = {
    [DevicePerformance.LOW]: 1400,
    [DevicePerformance.MID]: 2500,
    [DevicePerformance.HIGH]: 3400,
};

const DENSITY_LOWER_BOUND = 300;

/**
 * Returns a CSS color (green → red) representing how optimized a level's object
 * density is for the given device performance tier.
 */
export function densityColor(density: number, performance: DevicePerformance = DevicePerformance.MID) {
    const upperBound = densityUpperBound[performance];
    const score = clamp(map(density, DENSITY_LOWER_BOUND, upperBound, 1, 0), 0, 1) ** 0.5;
    return `color-mix(in oklab, lightgreen ${score * 100}%, #FF5252)`;
}
